<template>
 <div class="slider-placeholder" :style="backgroundStyle">
     
 </div>
</template>

<script>
//import team1 from '../../assets/landing_p/Team_photos/team_photo.jpg'
import team2 from '../../assets/landing_p/Team_photos/team_photo2.jpg'

import mobile_pic from '../../assets/landing_p/Team_photos/team_photo2.jpg'

export default {
    name: 'SalonWork',
    data() {
        return {
            /*images: [
                {desktop: salon_pic, mobile: mobile_pic},
                {desktop: girl_long_hair, mobile: mobile_pic}
            ]*/
           allDesktopImages: [
            //{ src: team1, alt: 'Salon Team'},
            { src: team2, alt: 'Salon Team'},
            
            ],///
           mobileImage: { src: mobile_pic, alt: 'Girl and makeup items'},///
           slides: [],
           currentIndex: 0,
           sliderInterval: null,
        };
    },
    computed: {
        // Returns the currently active image object
        currentImage() {
            return this.slides[this.currentIndex] || {};
        },

        backgroundStyle(){
            return {
                backgroundImage: `url(${this.currentImage.src})`
            }
        }
    },
    created() { //
        // Load all images when the component is created
        //this.importAllImages(import.meta.glob('@/assets/landing_p/salon_pics', false, '/\.(jpe?g|png)$i'));
        this.updateSlidesArray(); ///
    },
    mounted() {
        // Start the automatic sliding timer
        this.startSlider();
        // Event listener to handle screen changes to mobile view
        window.addEventListener('resize', this.handleResize); ///
        //this.updateMobileImage();
    },
    beforeUnmount() {
        // Clean up the timer and event listener
        clearInterval(this.sliderInterval);
        window.removeEventListener('resize', this.handleResize);
        clearTimeout(this.resizeTimeout); ///
    },
    methods: {
        handleResize() {
            // Debounced call to prevent excessive array loading
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(this.updateSlidesArray, 200);
        },

        /**
         * Determione the correct set of images (desktop or mobile)
         * and reloads the slides array if neccessary.
         */

        updateSlidesArray() {
            const isMobile = window.innerWidth <= 600;
            let newSlides;

            if (isMobile) {
                // Use only potrait image
                newSlides = [this.mobileImage]
            } else {
                // If desktop, use the array landscape images
                newSlides = this.allDesktopImages;
            }

            // Check if the slide set has actually changed
            // Check the length and the source of the first image
            if (this.slides.length === 0 || newSlides[0].src !== this.slides[0].src) {
                //clearInterval(this.sliderInterval); // stop timer
                this.slides = newSlides; // clear current slides
                this.currentIndex = 0;
                //this.importAllImages(require.context('@/assets/landing_p/salon_pics', false, /\.(jpe?g|png)$/i));
                
                //this.startSlider(); // restart the timer
                this.manageSliderInterval();
            }

        },

        /**
     * Manages starting or stopping the slider based on the current slide count.
     */
    manageSliderInterval() {
        // 1. Always clear any existing interval first to prevent ghosts
        clearInterval(this.sliderInterval);
        this.sliderInterval = null;

        // 2. Only start a NEW interval if there is more than one image
        if (this.slides.length > 1) {
            this.sliderInterval = setInterval(() => {
                // The main sliding logic
                this.currentIndex = (this.currentIndex + 1) % this.slides.length; 
            }, 5000); // Change the image every 5 seconds
        }
    },

    startSlider() {
        this.manageSliderInterval(); // Just points to the new management method
    }
    }
}
</script>

<style scoped>
 .slider-placeholder {
            background-color: #f5f5f4;
            height: 600px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            color: #5D0E1F;
            text-align: center;
            border-radius: 10px;
            margin-top: 2rem;
            box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
            overflow: hidden;
            width: 100%;

            background-position: center;
            background-size: cover;
            background-attachment: fixed;
            transition: background-image 0.9s ease-in-out
        }
 @media (max-width: 600px) {
  .slider-placeholder {
    padding-top: 133.33%; /* Taller container for the portrait image */
  }
}
</style>